import React from 'react';
import { FormFull } from "form-full";
import { Grid } from "@material-ui/core";
import { Input } from "../../../components/index";
import { Label } from "../../../components/inputs/Input";
import { InputTags, InputDate } from "../../../components/index";
import Styles from "../styles/";

function Filters({
    onSubmit,
    loading,
    placeList,
    profileList,
}: any) {
    const [formRef, setFormRef] = React.useState<any>(null);
    const [minDate, setMinDate] = React.useState<any>(null);

    const statusList = [
        { label: "Foto Pendente", value: "FP" },
        { label: "Acesso Liberado", value: "AL" },
        { label: "Acesso Finalizado", value: "AF" },
        { label: "Acesso Recusado", value: "AR" },
        { label: "Acesso Cancelado", value: "AC" },
    ];

    return (
        <FormFull formRef={setFormRef} onSubmit={(data) => onSubmit(data)}>
            <Grid alignItems="flex-end" container spacing={1}>
                <Grid item xs={12} md={6} lg={3}>
                    <Label>Nome</Label>
                    <Input name="name" label="" placeholder="Nome" />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Label>Imóvel</Label>
                    <InputTags
                        readOnly={loading}
                        name="placeNames"
                        options={placeList ? placeList : []}
                        defaultValue={formRef?.placeNames || null}
                        multiple={true}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <Label>Solicitação</Label>
                    <InputDate
                        onChange={(value) => {
                            setMinDate(value);
                            const end = formRef?.getValue("startDate");

                            if (end < value) {
                                formRef?.clearValue("startDate", false);
                            }
                        }}
                        name="solicitationDate"
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <Input name="vehiclePlate" label="Placa do Veículo" placeholder="Placa do Veículo" />
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <Label>Status</Label>
                    <InputTags
                        readOnly={loading}
                        name="status"
                        options={statusList ? statusList : []}
                        defaultValue={formRef?.status || null}
                    />
                </Grid>
            </Grid>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    width: "100%",
                }}
            >
                <Styles.ButtonContainer>
                    <Styles.Clear
                        loading={loading}
                        disabled={loading}
                        fullWidth={false}
                        action="clear"
                    >
                        Limpar
                    </Styles.Clear>
                </Styles.ButtonContainer>
                <Styles.ButtonContainer>
                    <Styles.Submit
                        loading={loading}
                        disabled={loading}
                        fullWidth={false}
                        action="submit"
                    >
                        Aplicar Filtros
                    </Styles.Submit>
                </Styles.ButtonContainer>
            </div>
        </FormFull>
    );
}

export default Filters;